import { platformSupabaseClient } from "@/adapters/platformSupabaseClient";
import { createAdminIdentitySupabasePort } from "@tihany/module-admin-adapter-supabase";
import type { AdminIdentityPort } from "@tihany/module-admin-contracts";

export const adminIdentityPort: AdminIdentityPort = createAdminIdentitySupabasePort(platformSupabaseClient);
